import script from "./RecommendedBrowserBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecommendedBrowserBanner.vue?vue&type=script&lang=ts&setup=true"

import "./RecommendedBrowserBanner.vue?vue&type=style&index=0&id=97dd51dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97dd51dc"]])

export default __exports__